import React from 'react';
import { ActionIcon, Group, Text, Tooltip, rem } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { motion } from 'framer-motion';
import { FADE } from '@/theme/motion';
import type { TypeNavNode } from '@/types/ui/types.ui.navigation';

type Props = {
    trail: TypeNavNode[];
    onBack: () => void;
};

const SpotlightPath: React.FC<Props> = ({ trail, onBack }) => (
    <motion.div variants={FADE} initial="hidden" animate="visible" exit="exit">
        <Group gap="xs" wrap="nowrap" px="sm" py={6} style={{ borderBottom: '1px solid var(--bd-border)' }}>
            <Tooltip label="Torna indietro (←)">
                <ActionIcon variant="subtle" color="gray" size="sm" onClick={onBack} aria-label="Torna al livello precedente">
                    <IconArrowLeft size={15} stroke={2} />
                </ActionIcon>
            </Tooltip>
            <Group gap={4} wrap="nowrap" style={{ minWidth: 0, overflow: 'hidden' }}>
                {trail.map((node, index) => {
                    const last = index === trail.length - 1;
                    return (
                        <React.Fragment key={node.id}>
                            <Text size="xs" fw={last ? 650 : 500} c={last ? undefined : 'dimmed'} style={{ whiteSpace: 'nowrap', color: last ? 'var(--bd-text-strong)' : undefined }}>
                                {node.label}
                            </Text>
                            <Text size="xs" c="dimmed" style={{ opacity: 0.6, marginRight: rem(2) }}>›</Text>
                        </React.Fragment>
                    );
                })}
            </Group>
        </Group>
    </motion.div>
);

export default SpotlightPath;
